import React from "react"

const OldOrders = () => {
  return (
    <div className='old-orders'>
      <div>
        <div className='header'>
          <i className='nc-icon nc-align-center' />
          <div>Old Orders</div>
        </div>
      </div>
      <ul>
        <li className='mb-3'>
          Various filters to help find an order that has been completed
        </li>
        <li>
          Action buttons
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-reply' />
            </button>
            <div>
              Restore an order to <b>All Orders</b>
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-file' />
            </button>
            <div>Print labels for the order</div>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default OldOrders
